import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Analytics, logEvent } from '../core/firebase/analytics';
import {
  NotificationSubscription,
  JobSubscriptionData,
} from '../types/notification';
import { environment } from '../../environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationSubscriptionService {
  private http = inject(HttpClient);
  private analytics = inject(Analytics);
  private readonly baseUrl = `${environment.apiBaseUrl}/v1/jobs/notification-subscriptions`;

  getJobNotificationSubscriptions(): Observable<
    NotificationSubscription<JobSubscriptionData>[]
  > {
    return this.http.get<NotificationSubscription<JobSubscriptionData>[]>(
      this.baseUrl
    );
  }

  async upsertNotificationSubscription(
    subscription: NotificationSubscription
  ): Promise<void> {
    await firstValueFrom(this.http.put<void>(this.baseUrl, subscription));

    if (subscription.id) {
      logEvent(this.analytics, 'notification_subscription_updated');
    } else {
      logEvent(this.analytics, 'notification_subscription_created');
    }
  }

  async deleteNotificationSubscription(subscriptionId: string): Promise<void> {
    await firstValueFrom(
      this.http.delete<void>(`${this.baseUrl}/${subscriptionId}`)
    );

    logEvent(this.analytics, 'notification_subscription_deleted');
  }
}
